'use strict';
module.exports = /^#!.*/;



//////////////////
// WEBPACK FOOTER
// ./~/shebang-regex/index.js
// module id = 1052
// module chunks = 0